import Vue from 'vue';
import FormLabel from '@/components/form/label.vue';

Vue.component('form-label', FormLabel);
